import { SecurityHeader } from "./security/SecurityHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AccessControlSettings } from "./AccessControlSettings";

export const SecuritySettings = () => {
  return (
    <div className="space-y-6">
      <SecurityHeader />
      <Tabs defaultValue="access-codes" className="space-y-4">
        <TabsList>
          <TabsTrigger value="access-codes">Codes d'accès</TabsTrigger>
        </TabsList>

        <TabsContent value="access-codes" className="space-y-4">
          <AccessControlSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};